import MESSAGE_KEY from '../login-message-key';

export default {
  [MESSAGE_KEY.LOGIN_TITLE]: 'Pyxis (GZ)',
  [MESSAGE_KEY.LOGIN_SUB_TITLE]: 'Pyxis (GZ) Website',
  [MESSAGE_KEY.LOGIN_FORM_TITLE]: 'User Login',
  [MESSAGE_KEY.ADA_TEXTBOX_PLACEHOLDER]: 'Input ada number please',
  [MESSAGE_KEY.CAPTCHA_TEXTBOX_PLACEHOLDER]: 'Input captcha please',
  [MESSAGE_KEY.TERM_DESCRIPTION]: 'I have read and agreed to all contents of the user agreement and privacy policy',
  [MESSAGE_KEY.COPYRIGHT_DESCRIPTION]: 'Copyright@2022 Pyxis(GZ) Information Technology Co., Ltd. All rights reserved.',
};